import { LIGHT_THEME_COLORS } from '../constants'
import '@mdi/font/css/materialdesignicons.css'
import { type VuetifyOptions, createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'

export default createVuetify({
  components,
  directives,
  defaults: {
    VBtn: {
      height: 50,
      color: 'primary',
      flat: true,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: LIGHT_THEME_COLORS,
      },
    },
  },
} as VuetifyOptions)
